<template>
  <div class="first-agent">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
          <FormItem>
            <Button type="success" @click="createFirstAgent()">新增</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="600"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="agents" :label-width="60" ref="agentsValidate" :rules="agentsValidate">
        <FormItem label="uuid" label-position="top">{{ agents.id }}</FormItem>
        <FormItem label="昵称" label-position="top">{{ agents.nickname }}</FormItem>
        <FormItem label="手机号" label-position="top">{{ agents.phone }}</FormItem>
        <FormItem label="姓名" label-position="top" prop="name">
          <Input v-model="agents.name"></Input>
        </FormItem>
        <FormItem label="入驻类型" label-position="top">
          <Select v-model="agents.in_type" clearable filterable placeholder="入驻类型">
            <Option :value="0">个人</Option>
            <Option :value="1">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="代理类型" label-position="top">
          <Select v-model="agents.type" clearable filterable placeholder="代理类型">
            <Option :value="1">导游</Option>
            <Option :value="2">民宿</Option>
            <Option :value="3">景点</Option>
          </Select>
        </FormItem>
        <FormItem label="简介" prop="describe">
          <Input v-model="agents.describe" type="textarea" :rows="4" placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="身份证正面照" prop="imageface">
          <upload-thumb
            v-model="agents.imageface"
            ref="imagefaceuploadthumb"
            :defaultList="imagefacethumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照" prop="imageback">
          <upload-thumb
            v-model="agents.imageback"
            ref="imagebackuploadthumb"
            :defaultList="imagebackthumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="营业执照照片" prop="company_photo">
          <upload-thumb
            v-model="agents.company_photo"
            ref="uploadthumb"
            :defaultList="thumblist"
            :autoCropWidth="154" :autoCropHeight="154"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="审核状态" label-position="top">
          <Select v-model="agents.status" clearable filterable placeholder="审核状态">
            <Option :value="0" :key="0">待审核</Option>
            <Option :value="1" :key="1">通过审核</Option>
            <Option :value="2" :key="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="editagent('agentsValidate')">提交</Button>
      </div>
    </Drawer>
    <Modal v-model="shenheStatus" title="审核" @on-ok="updateStatus()" :loading="loading">
      <Select v-model="reviewStatus" clearable filterable placeholder="审核状态">
        <Option :value="0" :key="0">待审核</Option>
        <Option :value="1" :key="1">通过审核</Option>
        <Option :value="2" :key="2">未通过审核</Option>
      </Select>
    </Modal>

    <Modal v-model="biliStatus" title="比例设置" @on-ok="updateBili()" :loading="loading">
      <span style="color:red;">*一级分销商分销收入从园区收入里进行抽取</span>
      <Form :model="biliModel" :label-width="136">
        <FormItem label="商城分销比例：" label-position="top">
          <Input v-model="biliModel.on_fx" placeholder="例如10">%</Input>
        </FormItem>
        <FormItem label="直接支付分销比例：" label-position="top">
          <Input v-model="biliModel.underline_fx" placeholder="例如10">%</Input>
        </FormItem>
      </Form>
    </Modal>
    <!--添加一级分销商-->
    <Modal v-model="showModalStatus2" title="添加一级分销商" @on-ok="ok" :width="800">
      <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table
        border
        :columns="columns2"
        ref="selection"
        :data="columns2List"
        :loading="dataloading"
        @on-selection-change="handleSelectRow()"
      ></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page
            ref="listPage1"
            :total="pages1.total"
            :current="pages1.page"
            :page-size="pages1.size"
            show-elevator
            show-total
            @on-change="changePage1()"
          ></Page>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "first-agent",
  data() {
    return {
      //抽屉参数
      value3: false,
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      biliModel: { on_fx: null, underline_fx: null },
      isClear: false,
      loading: true,
      dataloading: true,
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      cates: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      columns2List: [],
      pages1: {
        page: 1,
        size: 10
      },
      search_s: {},
      formItem: {
        key: ""
      },
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "UUID",
          key: "uuid",
          minWidth: 100
        },
        {
          title: "电话",
          key: "username",
          minWidth: 160
        }
      ],
      list: [
        {
          title: "用户",
          key: "name",
          width: 350,
          render: (h, params) => {
            var a = "";
            if (
              params.row.firstagent.userdata != null &&
              params.row.firstagent.userdata.username != null
            )
              a = params.row.firstagent.userdata.username;
            var b = "";
            if (params.row.firstagent.company != null)
              b = params.row.firstagent.company;
            var c = "";
            if (
              params.row.firstagent.userdata != null &&
              params.row.firstagent.userdata.nickname != null
            )
              c = params.row.firstagent.userdata.nickname;
            var d = "";
            if (
              params.row.firstagent.userdata != null &&
              params.row.firstagent.userdata.uuid != null
            )
              d = params.row.firstagent.userdata.uuid;
            var e = "";
            if (
              params.row.firstagent.user != null &&
              params.row.firstagent.user.openid != null
            )
              e = params.row.firstagent.user.openid;
            var f = "";
            if (
              params.row.firstagent.user != null &&
              params.row.firstagent.user.map_mp_openid != null
            )
              f = params.row.firstagent.user.map_mp_openid;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户名：" + a
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "名称：" + b
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "昵称：" + c
              ),
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                "用户ID：" + d
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "微信ID：" + e
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "小程序ID：" + f
              )
            ]);
          }
        },
        {
          title: "电话",
          key: "userdata.username",
          minWidth: 150,
          render: (h, params) => {
            var s = "";
            if (
              params.row.firstagent.userdata != null &&
              params.row.firstagent.userdata.username != null
            )
              s = params.row.firstagent.userdata.username;
            return h("span", s);
          }
        },
        {
          title: "状态",
          key: "describe",
          width: 150,
          render: (h, params) => {
            var s = "待审核";
            if (params.row.firstagent.status == 1) s = "审核通过";
            return h("span", s);
          }
        },
        {
          title: "注册时间",
          key: "created_at",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 400,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            var s = this.status == 1 ? "none" : "inline-block";
            var m = this.status != 1 ? "none" : "inline-block";
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: s
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showShenhe(
                        params.row.firstagent.first_agent_uuid,
                        params.row.status
                      );
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.firstagent.first_agent_uuid);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.goagentlist(params.row.firstagent.first_agent_uuid);
                    }
                  }
                },
                "二级分销商"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gotcrecord(params.row.firstagent.first_agent_uuid);
                    }
                  }
                },
                "提成记录"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showbili(params.row.firstagent.first_agent_uuid);
                    }
                  }
                },
                "提成比例设置"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      showModalStatus2: false,
      agents: {
        first_agent_uuid: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        in_type: 0,
        status: "0",
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      },
      agentsValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "change" }],
        describe: [
          { required: true, message: "简介必须填写", trigger: "change" }
        ],
        imageface: [
          { required: true, message: "请上传身份证正面", trigger: "change" }
        ],
        imageback: [
          { required: true, message: "请上传身份证反面", trigger: "change" }
        ],
        company_photo: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ]
      },
      status: 1,
      shenheStatus: false,
      shenheId: 0,
      reviewStatus: 0,
      biliStatus: false,
      park_uuid: ""
    };
  },
  watch: {
    "$route.params.park_uuid": function(curVal, oldVal) {
      if (curVal) {
        this.park_uuid = curVal;
        this.getTableList();
      }
    }
  },
  created: function() {
    this.park_uuid = this.$route.params.park_uuid;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },

  methods: {
    getTableList: function() {
      this.$api.firstagent
        .parklist({
          page: this.pages.page,
          size: this.pages.size,
          park_uuid: this.park_uuid
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    showShenhe(uuid, status) {
      this.shenheStatus = true;
      this.shenheId = uuid;
      this.reviewStatus = status;
    },
    showbili(uuid) {
      this.biliStatus = true;
      this.shenheId = uuid;
      this.$api.firstagent
        .parkdetail({ first_agent_uuid: uuid, park_uuid: this.park_uuid })
        .then(res => {
          if (res.code == 200) {
            var s = res.result;
            this.biliModel.on_fx = s.on_fx;
            this.biliModel.underline_fx = s.underline_fx;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    updateBili() {
      this.$api.firstagent
        .parkbili({
          park_uuid: this.park_uuid,
          uuid: this.shenheId,
          on_fx: this.biliModel.on_fx,
          underline_fx: this.biliModel.underline_fx
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
            this.biliStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    updateStatus() {
      this.$api.firstagent
        .reviewStatus({ uuid: this.shenheId, status: this.reviewStatus })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
            this.shenheStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    // 详情
    detail(index) {
      this.agents = {
        first_agent_uuid: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        status: "0",
        in_type: 0,
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];
      this.thumblist = [];

      this.$refs["agentsValidate"].resetFields();

      this.showModalStatus = !this.showModalStatus;
      this.agents.id = index;
      this.$api.firstagent.detail({ first_agent_uuid: index }).then(res => {
        this.agents.first_agent_uuid = res.result.first_agent_uuid;
        this.agents.name = res.result.name;
        this.agents.nickname = res.result.userdata.nickname;
        this.agents.phone = res.result.phone;
        this.agents.type = res.result.type;
        this.agents.status = res.result.status;
        this.agents.in_type = res.result.in_type;
        this.agents.describe = res.result.describe;
        let imgsArr =
          res.result.image == null ? [] : res.result.image.split(",");
        for (var i = 0; i < imgsArr.length; i++) {
          if (i == 0) {
            this.agents.imageface = res.result.image.split(",")[0];
            this.imagefacethumblist.push({
              name: res.result.image.split(",")[0],
              url: res.result.image.split(",")[0],
              status: "finished"
            });
          }
          if (i == 1) {
            this.agents.imageback = res.result.image.split(",")[1];
            this.imagebackthumblist.push({
              name: res.result.image.split(",")[1],
              url: res.result.image.split(",")[1],
              status: "finished"
            });
          }
        }
        this.agents.company_photo = res.result.company_photo;
        if (res.result.company_photo != null) {
          this.thumblist.push({
            name: res.result.company_photo,
            url: res.result.company_photo,
            status: "finished"
          });
        }
      });
    },
    // 修改
    editagent(name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.agents.imageface = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageface = "";
      }
      if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
        this.agents.imageback = this.$refs[
          "imagebackuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageback = "";
      }
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.agents.company_photo = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.agents.company_photo = "";
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {};
          params.first_agent_uuid = this.agents.first_agent_uuid; //是	string	代理商户UUID
          params.type = this.agents.type; //是	int	商户类型1导游2民宿3景点
          params.in_type = this.agents.in_type;
          params.name = this.agents.name; //否	string	姓名
          params.status = this.agents.status;
          params.describe = this.agents.describe; //否	string	简介
          params.image = this.agents.imageface + "," + this.agents.imageback; //否	string	身份证正反图集
          params.company_photo = this.agents.company_photo; //否	string	营业执照
          this.$api.firstagent.edit(params).then(res => {
            // console.log(this.agents);
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 去代理商户列表
    goagentlist(id) {
      this.$router.push("/firstagent/agent/" + id);
    },
    // 去代理商户提成记录
    gotcrecord(id) {
      this.$router.push("/firstagent/tc_record/" + id);
    },
    // 删除
    remove: function(uuid, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.partners.remove({ uuid: uuid, id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    change() {},
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        park_uuid: this.park_uuid
      };
      this.$api.firstagent.parklist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    createFirstAgent() {
      this.search_s.key = "";
      this.showModalStatus2 = true;
      this.selected = {};
      this.$api.firstagent.nobindagent().then(res => {
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 筛选
    renderTable1: function(name) {
      if (name != 1) {
        this.pages1.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size
      };
      this.$api.firstagent.nobindagent(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow(selection, index) {
      this.selected = this.$refs.selection.getSelection();
    },
    //选中提交
    ok() {
      this.tablelist1 = this.selected;
      this.$api.firstagent
        .firstagentadd({
          park_uuid: this.park_uuid,
          agentUuidArrs: this.selected
        })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.$Message.success(res.msg);
            this.showModalStatus2 = false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    changePage1() {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
